import React, { useMemo } from "react";
import styles from "./style.module.less";
import { ActivityDetailPopupRef } from "@/components/ActivityDetailPopup";
import ActivityDetailButton from "@/components/ActivityDetailButton";
import { trackGdp } from "@/utils/gio-report";
import { getChannel } from "@/utils/tools";
import { goToPageV2 } from "@/utils/common";
import { enhancedSafeChainFind } from "@/pages/par-marketing/configPage/utils";
import { processOssImage } from "@/utils/image";

interface TopButtonGroupProps {
  pageInfo: any;
  activityInfo: any;
  // 活动详情弹窗引用，用于替代页面跳转
  activityDetailPopupRef?: React.RefObject<ActivityDetailPopupRef>;
}

const TopButtonGroup: React.FC<TopButtonGroupProps> = ({
  pageInfo,
  activityInfo,
  activityDetailPopupRef,
}) => {
  const valCode = useMemo(() => {
    const result =
      enhancedSafeChainFind(pageInfo).base("reActivity")?.val?.val?.valCode;
    return result || pageInfo?.base?.[0]?.val?.valCode;
  }, [pageInfo]);

  const buttonImage = useMemo(() => {
    const result = enhancedSafeChainFind(pageInfo.visual)
      ?.prizeSetting("btnSetting")
      ?.content("raffleFlipCardDetailBtn")?.val?.val;
    return result || pageInfo?.visual?.prizeSetting[1]?.content[1]?.val || "";
  }, [pageInfo]);

  const backgroundImage = useMemo(() => {
    const result = enhancedSafeChainFind(pageInfo.visual)
      ?.prizeSetting("btnSetting")
      ?.content("raffleFlipCardRecordBtn")?.val?.val;
    return result || pageInfo?.visual?.prizeSetting[1]?.content[2]?.val || "";
  }, [pageInfo]);

  const handleLuckyRecordClick = () => {
    trackGdp("P20189", "B004", {
      trackName: "充电_营销专题页_组件点击",
      origin: getChannel(),
      userType: "",
      versionId: activityInfo.versionCode,
      pageId: activityInfo.pageCode,
      ComponentCode: activityInfo.moduleId,
      type: activityInfo.moduleType,
      activityId: activityInfo.connectedActivitiesId,
      comp_style: JSON.parse(activityInfo.moduleJson).visual?.visualData[0]
        ?.typeName,
      status: "",
      clickLocation: "中奖记录",
    });
    goToPageV2({
      hash: `/luckyRecord?activityCode=${valCode}`,
    });
  };

  return (
    <div className={styles.topBtnList}>
      {/* 活动详情按钮 */}
      <ActivityDetailButton
        mode="activityCode"
        activityInfo={activityInfo}
        data={valCode}
        activityDetailPopupRef={activityDetailPopupRef}
        buttonImage={buttonImage}
        componentType="lottery"
        className={styles.topBtn}
      />
      {/* 中奖记录按钮 */}
      <span
        className={styles.topBtn}
        style={{
          background: `url(${processOssImage(backgroundImage)}) 0 0 / cover no-repeat`,
        }}
        onClick={handleLuckyRecordClick}
      />
    </div>
  );
};

export default TopButtonGroup;
